import React from 'react';
import {observer, inject} from 'mobx-react';

@inject('contentStore')
@observer
class ImportantLinks extends React.Component {
  render() {
    let importantLinks = this.props.contentStore.important_links;
    return (
      <div>{importantLinks.length > 0 &&
      importantLinks.sort((a,b) => a.index< b.index? -1:1).map((item, index) => (
        <p key={index}><a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a></p>
      ))
      }</div>
    );
  }
}

export default ImportantLinks;


// WEBPACK FOOTER //
// ./src/components/Home/ImportantLinks.js